import React from "react";
import './snpDistance.css';

import { Card, Table } from "react-bootstrap";
import {
  Label,
  Input,
  Button,
  Spinner
} from 'reactstrap'


import {
  fetchSNPTrackingData
} from '../../actions';

import { toast } from 'react-toastify';
import { connect } from "react-redux";
import moment from 'moment';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { appInsights } from "../../AppInsights";
import { SeverityLevel } from '@microsoft/applicationinsights-common';

import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import TrackSnpDistance from '../TrackSNPDistance/trackSNPdistance'
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";

const initialState = {
  labelsVisibility: null,
  yWidth: 40,
  displayYLabels: true,
  cursor: "",
  onClick: () => {},
  squares: false,
  xi: null,
  yi: null,
  groupColors: ['#ffffff', '#375f78', '#5fb3d4', '#82c3da'],
  clickedCell: [],
  checkX: localStorage.getItem("guest")?['1901', '1903', '1905', '1908']:[],
  checkY: localStorage.getItem("guest")?['1906', '1902', '1904', '1907']:[],
  UnCheckedX: null,
  UnCheckedY: null,
  uncheck: null,
  SNP:false,
  selectedpairs:[],
  resultsData:[],
  loader: false
}

class SNPGridDisplay extends React.Component{
    constructor(props) {
        super(props);
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.state = {
          ...initialState
      }
      setTimeout(() => {
        if(localStorage.getItem("guest"))
        this.applySNP()
    });
    }
    
    cellStyle = (background, value, min, max) => ({
      background,
      opacity: (value - min) / (max - min) || 0,
    })


  onClick = (samples, xi, yi) => {
    this.setState({
      clickedCell: samples,
      cellName: `${samples[0].sample.barcode} & ${samples[1].sample.barcode}`,
      xi: xi,
      yi: yi
    })
  }

  handleChangeX = (event) => {
    let listX = this.state.checkX
    if(event.target.checked){
      let index = this.state.uncheck==null?this.state.checkX.length:this.state.uncheck
      listX.splice(index, 0, event.target.name)
      this.setState({
        checkX: listX,
        UnCheckedXOpp: null,
        uncheck: null,
        lastCheck: 'x',
        SNP:false
      });
    }
    else{
      let index = this.state.checkX.indexOf(event.target.name)
      let check = this.state.checkX.length===this.state.checkY.length?index:null
      listX.splice(index, 1)
      this.setState({
        checkX: listX,
        UnCheckedXOpp: this.state.checkY.length>index?this.state.checkY[index]:null,
        uncheck: this.state.checkY.length>index?check:null,
        lastCheck: null,
        SNP:false
      });
    }
  }

  handleChangeY = (event) => {
    let listY = this.state.checkY
    if(event.target.checked){
      let index = this.state.uncheck==null?this.state.checkY.length:this.state.uncheck
      listY.splice(index, 0, event.target.name)
      this.setState({
        checkY: listY,
        UnCheckedYOpp: null,
        uncheck: null,
        lastCheck: 'y',
        SNP:false
      });
  }
    else{
      let index = this.state.checkY.indexOf(event.target.name)
      let check = this.state.checkY.length===this.state.checkX.length?index:null
      listY.splice(index, 1)
      this.setState({
        checkY: listY,
        UnCheckedYOpp: this.state.checkX.length>index?this.state.checkX[index]:null,
        uncheck: this.state.checkX.length>index?check:null,
        lastCheck: null,
        SNP:false
      });
    }
  }

  DataTable = (sample) => {
    return (<Table borderless>
        <tbody>
            {sample.sample.barcode ?
                <tr>
                    <td className="bodyCopy">{sample.sample.barcode}</td>
                </tr>
                : null
            }
            {sample.sample.type_of_analysis ?
                <tr>
                  <td className="bodyCopy" >{moment(new Date(sample.sample.date_time)).format('MMM D, YYYY HH:mm')}</td>
                </tr>
                : null
            }
            {sample.sample.location ?
                <tr>
                    <td className="bodyCopy">{sample.sample.location.location_id + (sample.sample.unit ? `_${sample.sample.unit.unit_id}` : '')}</td>
                </tr>
                : null
            }
            {sample.sample.type_of_analysis ?
                <tr>
                    <td className="bodyCopy">{sample['sample'].type_of_analysis}</td>
                </tr>
                : null
            }
            {sample.sample.type_of_samples ?
                <tr>
                    <td className="bodyCopy">{sample.sample.type_of_samples}</td>
                </tr>
                : null
            }
            {sample.novel_type ?
                <tr>
                    <td className="bodyCopy snp-text-bold">NT{sample.novel_type}</td>
                </tr>
                : null
            }
        </tbody>
    </Table>)
}

handleKeyDown = (e) => {
  let totalNum = this.props.labels.length
  if (e.keyCode === 37) {
    let x = this.state.xi?this.state.xi-1:totalNum-1
    this.setState({ xi: x,
      clickedCell: [this.props.data[x][totalNum], this.props.data[this.state.yi][totalNum]],
      cellName: `${this.props.data[x][totalNum].sample.barcode} & ${this.props.data[this.state.yi][totalNum].sample.barcode}`,
    })
  } else if (e.keyCode === 38) {
    let y = this.state.yi?this.state.yi-1:totalNum-1
    this.setState({ yi: y,
      clickedCell: [this.props.data[this.state.xi][totalNum], this.props.data[y][totalNum]],
      cellName: `${this.props.data[this.state.xi][totalNum].sample.barcode} & ${this.props.data[y][totalNum].sample.barcode}`,
    })
  } else if (e.keyCode === 39) {
    let x = totalNum-1===this.state.xi?0:this.state.xi+1
    this.setState({ xi: x,
      clickedCell: [this.props.data[x][totalNum], this.props.data[this.state.yi][totalNum]],
      cellName: `${this.props.data[x][totalNum].sample.barcode} & ${this.props.data[this.state.yi][totalNum].sample.barcode}`,
    })
  }else if(e.keyCode === 40) {
    let y = totalNum-1===this.state.yi?0:this.state.yi+1
    this.setState({ yi: y,
      clickedCell: [this.props.data[this.state.xi][totalNum], this.props.data[y][totalNum]],
      cellName: `${this.props.data[this.state.xi][totalNum].sample.barcode} & ${this.props.data[y][totalNum].sample.barcode}`
    })
  }
}
  applySNP = () => {
    let selectedX = this.state.checkX
    let selectedY = this.state.checkY
    let selectedbarcodes = [...new Set([...selectedX,...selectedY])]
    let barcodePairs = []
    this.props.selectedfilters['barcode']=selectedbarcodes ? selectedbarcodes.toString():""
    let lengthX = selectedX.length
    let lengthY = selectedY.length
    if ( lengthX === lengthY && lengthX > 0) {
      for(let i = 0;i<lengthX;i++){
        barcodePairs[i] = [selectedX[i],selectedY[i]] 
      }
      this.setState({loader: true})
      this.props.fetchSNPTrackingData(this.props.selectedfilters).then(response => {
        if(response.status === 200){
          appInsights.trackTrace({message: 'SNP Tracking Data is fetched successfully', properties:{page: "snpGridDisplay", id: selectedbarcodes}, severityLevel: SeverityLevel.Information});
          this.setState({resultsData:response.data,
          SNP: true,
          loader: false,
          selectedbarcodes: selectedbarcodes,
          barcodePairs: barcodePairs})
        }
        else{
          this.setState({loader: false})
          appInsights.trackTrace({message: 'Error in fetching SNP Tracking Data', properties:{page: "snpGridDisplay", id: selectedbarcodes}, severityLevel: SeverityLevel.Error});
        }
      }).catch((error) => {
        this.setState({loader: false})
        let message = "Errors in loading locations data!"
        appInsights.trackTrace({message: 'Error in fetching SNP Tracking Data', properties:{page: "snpGridDisplay", id: selectedbarcodes, error: error}, severityLevel: SeverityLevel.Error});
        toast.error(message, {
            position: toast.POSITION.BOTTOM_RIGHT
        });
    });
    }
    else {
      let message
      if(lengthX < lengthY){
        message = "Please select the barcode pair for " + selectedY[lengthY-1]
      }
      else if(lengthX > lengthY){
        message = "Please select the barcode pair for " + selectedX[lengthX-1]
      }
      else{
        message = "Please select a barcode pair "
      }
      appInsights.trackTrace({message: message, properties:{page: "snpGridDisplay"}, severityLevel: SeverityLevel.Verbose});
      toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT
      });
    }
  }

  render(){
    const totalNum = this.props.labels.length;
    var settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 6,
      slidesToScroll: 6,
      initialSlide: 0,
      responsive: [
          {
              breakpoint: 1024,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
              }
          },
          {
              breakpoint: 600,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
              }
          },
          {
              breakpoint: 480,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: true,

              }
          }
      ]
  };
  
    return (
      <div>
        <div className="carousel">
          <Row>
            <Col className="result-details-header">
              <span className="snp-text-bold span-ct-snp">CT</span>
              <span className="text-description">- Complex Type  |  </span>
              <span className="snp-text-bold span-st-snp">ST</span>
              <span className="text-description">- Sequence Type  |  </span>
              <span className="snp-text-bold span-nt-snp">NT</span>
              <span className="text-description">- Novel Type  |  </span>
              <span className="snp-text-bold span-snp-results">SNP</span>
              <span className="text-description">- Single nucleotide polymorphisms</span>
            </Col>
          </Row>
          <Row className="d-flex justify-content-between bd-highlight mb-2 snp-overview-header">
              <Col className="d-flex bd-highlight result-label grid-legend-col">
                <span className="legend-range">Legend -</span>
                <div className="legend-box box-div-group1" /><div className="legend-range">{`1-${this.props.groups[0]}`}</div>
                <div className="legend-box box-div-group2" /><div className="legend-range">{`${parseInt(this.props.groups[0])+1}-${this.props.groups[1]}`}</div>
                <div className="legend-box box-div-group3" /><div className="legend-range">{`>${this.props.groups[1]}`}</div>
              </Col>
          </Row>
        </div>
        <Row>
          <Col className="bd-highlight room-name ">{this.state.cellName ? "Barcodes: "+this.state.cellName : null}</Col>
        </Row>
        {this.state.clickedCell.length>0 ?
            <Slider {...settings}>
              {this.state.clickedCell.map((sample) => {
                return (
                    <div>
                        <Card className="snp-result-card">
                            <Card.Body className="d-flex p-2 candidate-card">
                                <div className="sample-box" />
                                  {this.DataTable(sample)}
                            </Card.Body>
                        </Card>
                    </div>
                )})
              }
            </Slider>:null}
        <div className="matrix-grid-snp">
          <div className="heatmap-xaxis">
          <div className="header-main snp-text-bold">Barcodes</div>
            {this.props.labels.map((x, i) => (
              <Label className={"heatmap-xlabel snp-text-bold"+(this.state.xi===i?" label-underline-snp":"")}>
                    <Input type="checkbox" name={x} checked={this.state.checkX.includes(x)} className="input-checkbox-snp"
                      disabled={this.state.UnCheckedYOpp===x || (this.state.checkX[this.state.checkX.length-1]===x&&this.state.lastCheck==='x')?false:(this.state.checkY.length===this.state.checkX.length?false:(this.state.checkX.length>this.state.checkY.length?true:this.state.checkX.includes(x)))}
                      onClick={this.handleChangeX}/>
                {x}
              </Label>
              ))
            }
          </div>
            {this.props.labels.map((y, yi) => (
              <div className="value-grid-snp" tabIndex="0" onKeyDown={ this.handleKeyDown }>
                <div className="label-value-snp">
                  <Label className={"heatmap-ylabel snp-text-bold"+(this.state.yi===yi?" label-underline-snp":"")}>
                    <Input className="input-checkbox-snp" type="checkbox" name={y} checked={this.state.checkY.includes(y)}
                      disabled={this.state.UnCheckedXOpp===y||(this.state.checkY[this.state.checkY.length-1]===y&&this.state.lastCheck==='y')?false:(this.state.checkY.length===this.state.checkX.length?false:(this.state.checkY.length>this.state.checkX.length?true:this.state.checkY.includes(y)))}
                      onClick={this.handleChangeY}/>
                    {y}
                  </Label>
                </div>
                {this.props.labels.map((x, xi) => {
                  const value = this.props.data[yi][xi];
                  let background = value===0?this.state.groupColors[0]:(value<=this.props.groups[0]?this.state.groupColors[1]:(value<=this.props.groups[1]?this.state.groupColors[2]:this.state.groupColors[3]))
                  const style = {
                      background: background,
                      border: (this.state.xi===xi && this.state.yi===yi)?"solid 3px blue": "solid 3px white",
                      color: background===this.state.groupColors[0]?"rgb(68, 68, 68)": "white"
                  }
                  return (
                    <OverlayTrigger
                        delay={{ hide: 450, show: 600 }}
                        overlay={(props) => (
                          <Tooltip {...props}>
                            <div className="grid-tooltip-snp">
                              {[this.props.data[yi][totalNum], this.props.data[xi][totalNum]].map((sample) => this.DataTable(sample))}
                            </div>
                          </Tooltip>
                        )}
                        placement="bottom"
                      >
                    <div className="heatmap-cell" 
                      onClick={() => this.onClick([this.props.data[xi][totalNum], this.props.data[yi][totalNum]], xi, yi)}
                      key={`${xi}_${yi}`}
                      style={style}
                    >
                      <div className="heatmap-cell-render">
                        {this.props.cellRender(value, x, y)} 
                      </div>
                    </div>
                    </OverlayTrigger>
                  );
                })}
              </div>
            ))}
        </div>
        <div className="snp-align-right">
          <Button id="applyFloorButton" type="submit" onClick={this.applySNP}>Apply{this.state.loader ? <Spinner className="sample-floor-spinner"/> : null}</Button>
        </div>
          {this.state.SNP ?
              <TrackSnpDistance resultsData={this.state.resultsData}
                barcodePairs={this.state.barcodePairs}
                selectedbarcodes={this.state.selectedbarcodes}
                SNPreaultData={this.props.SNPreaultData}
                selectedfilters={this.props.selectedfilters}
                groups={this.props.groups} 
              />
          :
          null}
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
      locationData: state.location_data.locationData,
  }
}

export default connect(
  mapStateToProps,
  {
      fetchSNPTrackingData
  }
)(SNPGridDisplay)

